import { cn } from '../../lib/utils';

type CardProps = {
    className?: string;
    children?: React.ReactNode;
};

const CardRoot = ({ children, className }: CardProps) => {
    return (
        <div className={cn(`relative flex flex-col flex-1 shadow-xl px-3 py-6 md:p-6 lg:px-3 xl:px-6 hover:shadow-2xl`, className)}>{children}</div>
    );
};

const CardTitle = ({ children, className }: CardProps) => {
    return <div className={cn(`text-primary text-xl`, className)}>{children}</div>;
};

const CardSubtitle = ({ children, className }: CardProps) => {
    return <div className={cn(`text-active text-sm`, className)}>{children}</div>;
};

const CardContent = ({ children, className }: CardProps) => {
    return <div className={cn(`flex flex-col text-primary text-base my-6 gap-3`, className)}>{children}</div>;
};

export const Card = Object.assign(CardRoot, {
    Title: CardTitle,
    Subtitle: CardSubtitle,
    Content: CardContent,
});
